import './App.css';
import {LayoutMaster} from "./layouts/master";
import {PrivateRoute} from "./layouts/private-route";
import {NotFound} from "./components/not-found/not-found";
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import React from 'react';
import {Unsubscribe} from "./components/email/unsubscribe/unsubscribe";
import {Login} from "./components/auth/login";
import routes from "./routes";
import Loading from "./layouts/loading";

function App() {
    return (
        <BrowserRouter>
            <React.Suspense fallback={<Loading/>}>
                <Routes>
                    <Route element={<PrivateRoute/>}>
                        <Route path="/" element={<LayoutMaster/>}>
                            <Route path="/" element={<Navigate to="/mail" replace />} />
                            {routes.map(({path, component: Component}, index) => (
                                <Route key={index} path={path} element={<Component/>}/>
                            ))}
                        </Route>
                    </Route>
                    <Route path={"/login"} element={<Login />} />
                    <Route path={"/unsubscribe"} element={<Unsubscribe />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </React.Suspense>
        </BrowserRouter>
    );
}

export default App;
